import {Form, Tabs} from 'antd';
import {FormInstance} from 'antd/es/form/Form';
import React, {FC, useEffect} from 'react';

import {showMessage} from 'shared/utils';

import {PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS} from '../model/project-investment-info-item-modal.constants';
import {IProjectInfluenceItemForm} from '../model/project-investment-info-item-modal.types';
import {FinancialIndicators} from './components/financial-indicators';
import {FinancialSourcesWrapper} from './components/financial-sources-wrapper';
import {InvestorsList} from './components/investors-list';
import {MainInfoTab} from './components/main-info-tab';
import {TargetIndicators} from './components/target-indicators';

import './project-investment-info-item-modal-form.less';

const {TabPane} = Tabs;

interface IProjectInvestmentInfoItemModalFormProps {
    form: FormInstance<any>;
    handleFinish: () => void;
    activeTab: string;
    setActiveTab: (tab: string) => void;
}

export const ProjectInvestmentInfoItemModalForm: FC<IProjectInvestmentInfoItemModalFormProps> = ({
    form,
    activeTab,
    setActiveTab,
    handleFinish,
}: IProjectInvestmentInfoItemModalFormProps) => {
    useEffect(() => {
        const initialValues: Partial<IProjectInfluenceItemForm> = {
            investors: [{
                id:null,
                investorName: '',
                investorShortName: '',
                investorInn: '',
                investorForeignRegNumber: '',
                participationRate: null,
                codeOksm: null,
                investorDescription: '',
                foreignInvestor: undefined
            }],
            finSources: [{
                id: null,
                finSourceValues: [{
                    id: null,
                    finSourceYear: null,
                    finSourcePlannedYearSum: null
                }],
                finSourceDescription: '',
                finSourceName: '',
                finSourceInn: '',
                finSourceForeignRegNumber: ''
            }],
            targetIndicators: {
                workplacesCount: null,
                increasedRevenue: null,
                increasedRevenuePercentage: null,
                productionIndicators: [],
                goalIndicators: []
            },
            financialIndicators: {
                finTotalAmount: null,
                finConstructionSiteAmount: null,
                finReconstructionAmount: null,
                finTechUpgradeAmount: null,
                finAssetModernAmount: null,
                finTaxpayerSum: null,
                planInvestTotal: null,
                planInvestSmrSum: null,
                planInvestEquipmentSum: null,
                planInvestOtherSum: null,
                planInvestPirSum: null,
                planInvestItSum: null,
                factYearInvestTotal: null,
                factYearInvestSmrSum: null,
                factYearInvestEquipmentSum: null,
                factYearInvestPirSum: null,
                factYearInvestItSum: null,
                factInvestTotal: null,
                factInvestSmrSum: null,
                factInvestEquipmentSum: null,
                factInvestOtherSum: null,
                factInvestPirSum: null,
                factInvestItSum: null,
                planned1YearInvestSum: null,
                planned2YearInvestSum: null,
                planned3YearInvestSum: null,
                planned4YearInvestSum: null,
                planned5YearInvestSum: null
            }
        };

        form.setFieldsValue(initialValues);
    }, [form]);
    return (
        <Form<IProjectInfluenceItemForm>
            className="project-investment-info-item-modal-form"
            form={form}
            layout="vertical"
            onFinish={handleFinish}
            onFinishFailed={()=>{
                showMessage({
                    message: 'Не все поля прошли валидацию, проверьте заполненные данные во всех вкладках',
                    isError: true,
                });
            }}
        >
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <TabPane
                    tab="Основная информация"
                    key={PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS.MAIN}
                >
                    <MainInfoTab form={form} />
                </TabPane>
                <TabPane
                    tab="Целевые показатели"
                    key={PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS.TARGET_INDICATORS}
                    forceRender
                >
                    <TargetIndicators />
                </TabPane>
                <TabPane
                    tab="Финансовые показатели"
                    key={PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS.FINANCIAL_INDICATORS}
                    forceRender
                >
                    <FinancialIndicators />
                </TabPane>
                <TabPane
                    tab="Инвесторы"
                    key={PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS.INVESTORS}
                    forceRender
                >
                    <InvestorsList />
                </TabPane>
                <TabPane
                    tab="Источники финансирования"
                    key={PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS.FINANCIAL_SOURCE}
                    forceRender
                >
                    <FinancialSourcesWrapper />
                </TabPane>
            </Tabs>
        </Form>
    );
}
